var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 3.85786 4.35786 0.5 8.5 0.5C12.6421 0.5 16 3.85786 16 8C16 12.1421 12.6421 15.5 8.5 15.5C4.35786 15.5 1 12.1421 1 8Z",
    fill: "#22C55E",
    stroke: "#F3F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5162 5.04977C12.6724 5.20598 12.6724 5.45925 12.5162 5.61546L7.18288 10.9488C7.02667 11.105 6.7734 11.105 6.61719 10.9488L4.48386 8.81546C4.32765 8.65925 4.32765 8.40598 4.48386 8.24977C4.64007 8.09356 4.89333 8.09356 5.04954 8.24977L6.90003 10.1003L11.9505 5.04977C12.1067 4.89356 12.36 4.89356 12.5162 5.04977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Checkbox.8fd2f30365caef35ef0b5ed8751c4668.svg";
export { ForwardRef as ReactComponent };